export default __webpack_public_path__ + "static/media/success-icon.93cfaf60.svg";